import { Skeleton } from '@/components/ui';

function MemberCardSkeleton() {
  return (
    <div className="flex items-start justify-between rounded-xl border border-border bg-card p-4">
      <div className="flex flex-col gap-1.5">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-5 w-20 rounded-full" />
        </div>
        <Skeleton className="h-3.5 w-36" />
      </div>
      <div className="flex gap-1">
        <Skeleton className="h-8 w-8 rounded-md" />
        <Skeleton className="h-8 w-8 rounded-md" />
      </div>
    </div>
  );
}

export function SettingsMembersSkeleton() {
  return (
    <div className="flex flex-col gap-3 px-5 py-6">
      <MemberCardSkeleton />
      <MemberCardSkeleton />
    </div>
  );
}
